import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ProtectedRoutePGI from "../components/ProtectedRoutePGI";
import Calculator from "../pages/Calculator";
import Contact from "../pages/Contact";
import UploadCV from "../pages/UploadCV";
import Layout from "../pages/Layout";
import Page404 from "../pages/Page404";
import WhereBuy from "../pages/WhereBuy";
import Institucional from "../pages/Institucional";
import GaleriaFotos from "../pages/GaleriaFotos";
import EnElMundo from "../pages/EnElMundo";
import Products from "../pages/Products";
import ListaProducto from "../components/products/ListaProducto";
import PreguntasFrecuentes from "../pages/PreguntasFrecuentes";
import ResultadoBusqueda from "../pages/ResultadoBusqueda";
import InstalacionProductos from "../pages/instalacionProductos";
import DetalleProducto from "../pages/productos/DetalleProducto";
import Noticias from "../pages/Noticias";
import NoticiaMultimedia from "../pages/NoticiaMultimedia";
import TensoliteNFT from "../pages/TensoliteNFT";
import VistaProductoNFT from "../pages/VistaProductoNFT";
import TensoBlog from "../pages/TensoBlog";
import Clientes from "../pages/Clientes";
import Login from "../pages/Login";
import LoginCliente from "../pages/LoginCliente";
import RegistroCliente from "../pages/RegistroCliente";
import RecuperoPassword from "../pages/RecuperoPassword";
import { ArticleSliderProvider } from "../context/ArticleSliderProvider";
import { NewsProvider } from "../context/NewsProvider";
import { MapsProvider } from "../context/MapsProvider";
import { ProductProvider } from "../context/ProductProvider";
import { FaqsProvider } from "../context/FaqsProvider";
import { WhereBuyProvider } from "../context/WhereBuyProvider";
import { PgiModulesProvider } from "../context/PgiModulesProvider";
import { ImageProvider } from "../context/ImageProvider";
import LayoutPgi from "../pages/pgi/LayoutPgi";
import HomePgi from "../pages/pgi/HomePgi";
import HomePgiNews from "../pages/pgi/HomePgiNews";
import ProductosPgi from "../pages/pgi/ProductosPgi";
import { HomeProvider } from "../context/HomeProvider";
import Config from "../pages/pgi/Config";
import SubProductosPgi from "../pages/pgi/SubProductos";
import GaleriaPgi from "../pages/pgi/GaleriaPgi";
import ReactGa from "react-ga";
import { getSocialMediaByName } from "../services/getSocialMedia";
import { LocationProvider } from "../context/LocationProvider";
import routesNewsSeo from "../exports/routesNewsSeo";
import FaqsHomePgi from "../pages/pgi/FaqsHomePgi";
import { BusinessProvider } from "../context/BusinessProvider";
import BusinessPgi from "../pages/pgi/BusinessPgi";
import { InTheWorldProvider } from "../context/InTheWorldProvider";
import InTheWorldPgi from "../pages/pgi/InTheWorldPgi";
import { CalculatorProvider } from "../context/CalculatorProvider";
import CalculatorPGI from "../pages/pgi/CalculatorPGI";
import CorralonesPgi from "../pages/pgi/CorralonesPgi";
import { CorralonesFilterProvider } from "../context/CorralonesFilterProvider";
import FooterPgi from "../pages/pgi/FooterPgi";
import { FooterProvider } from "../context/FooterProvider";
import { BuscadorProvider } from "../context/BuscadorProvider";
import IndexNotificaciones from "../pages/pgi/IndexNotificaciones--.jsx";
import { AuditProvider } from "../context/AuditProvider";
import Usuarios from "../pages/pgi/Usuarios";
import TensoNews from "../pages/TensoNews";
import NewsTensoBlog from "../components/Tensoblog/NewsTensoBlog";
import SectionsClientsPgi from "../pages/pgi/SectionClientsPgi";
import { SectionClientsProvider } from "../context/SectionClientsProvider";
import ProtectedRouteClients from "../components/ProtectedRouteClients";
import { ClientsProvider } from "../context/ClientsProvider";
import NewPassword from "../pages/NewPassword";
import GaleriaPgiV2 from "../pages/pgi/GaleriaPgiV2";

const Home = lazy(() => import("../pages/Home"));

const AppRouter = () => {
  useEffect(() => {
    const EventosAnimados = () => {
      const altoDeViewPortDelCliente = document.body.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      const inRightElements = Array.from(
        document.getElementsByClassName("inRight")
      );
      const inLeftElements = Array.from(
        document.getElementsByClassName("inLeft")
      );
      const inDownElements = Array.from(
        document.getElementsByClassName("inDown")
      );
      const inUpElements = Array.from(document.getElementsByClassName("inUp"));
      const inElements = Array.from(document.getElementsByClassName("in"));
      const imgParallaxY = Array.from(
        document.getElementsByClassName("img-parallax-y")
      );
      const imgParallaxX = Array.from(
        document.getElementsByClassName("img-parallax-x")
      );
      const zoomOutElements = Array.from(
        document.getElementsByClassName("zoomOut")
      );
      inRightElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.6) {
          item.classList.remove("inRight");
          item.classList.add("fadeInRight");
        }
      });
      inLeftElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.4) {
          item.classList.remove("inLeft");
          item.classList.add("fadeInLeft");
        }
      });
      inDownElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inDown");
          item.classList.add("fadeInDown");
        }
      });
      inUpElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inUp");
          item.classList.add("fadeInUp");
        }
      });
      inElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.4) {
          item.classList.remove("in");
          item.classList.add("fadeIn");
        }
      });
      imgParallaxY.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.4) {
          item.style.transform = `translateY(${scrollTop * -0.2}px)`;
        }
      });
      imgParallaxX.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.6) {
          item.style.transform = `scale(${scrollTop * -0.2})`;
        }
      });
      zoomOutElements.forEach((item) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.2) {
          item.classList.remove("zoomOut");
          item.classList.add("fadeZoomOut");
        }
      });
    };
    EventosAnimados();
    window.addEventListener("scroll", EventosAnimados);
    return () => {
      window.removeEventListener("scroll", EventosAnimados);
    };
  }, []);

  useEffect(() => {
    if(!window.location.pathname.includes('pgi')) {
      const callbellSettings = {
        token: "J9YBj3UDntq6sC6dU3nAnfyR",
      };
  
        (function () {
          var w = window;
          var ic = w.callbell;
          if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", callbellSettings);
          } else {
            var d = document;
            var i = function () {
              i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
              i.q.push(args);
            };
            w.Callbell = i;
            var l = function () {
              var s = d.createElement("script");
              s.type = "text/javascript";
              s.async = true;
              s.src =
                "https://dash.callbell.eu/include/" +
                window.callbellSettings.token +
                ".js";
              var x = d.getElementsByTagName("script")[0];
              x.parentNode.insertBefore(s, x);
            };
            if (w.attachEvent) {
              w.attachEvent("onload", l);
            } else {
              w.addEventListener("load", l, false);
            }
          }
        })();
    }
  }, []);
  const newsSeo2 = [...routesNewsSeo[0]];
  const newsSeo = newsSeo2.concat(routesNewsSeo[0]);
  const productSeo = [
    {
      oldPath: "/productos/detalle/tensoquines",
      newPath: "/producto/tensoquines",
      linea: true,
      id: 1,
    },
    {
      oldPath: " /productos/detalle/tensoblock",
      newPath: "/producto/tensoblock",
      linea: true,
      id: 2,
    },
    {
      oldPath: "/productos/detalle/postes",
      newPath: "/producto/postes",
      linea: true,
      id: 3,
    },
    {
      oldPath: "/productos/detalle/t21",
      newPath: "/producto/viguetas-t21",
      linea: true,
      id: 4,
    },
    {
      oldPath: "/productos/detalle/t180",
      newPath: "/producto/viguetas-t180",
      linea: true,
      id: 5,
    },
    {
      oldPath: "/productos/detalle/tejalite",
      newPath: "/producto/tejalite",
      linea: true,
      id: 6,
    },
    {
      oldPath: "/productos/detalle_especiales/estructuras",
      newPath: "/producto-especial/estructuras",
      linea: false,
      id: 7,
    },
    {
      oldPath: "/productos/detalle_especiales/tribunas",
      newPath: "/producto-especial/tribunas",
      linea: false,
      id: 8,
    },
    {
      oldPath: "/productos/detalle_especiales/pasarelas",
      newPath: "/producto-especial/pasarelas",
      linea: false,
      id: 9,
    },
    {
      oldPath: "/productos/detalle_especiales/vigas",
      newPath: "/producto-especial/vigas",
      linea: false,
      id: 10,
    },
    {
      oldPath: "/productos/detalle_especiales/otros",
      newPath: "/producto-especial/otros",
      linea: false,
      id: 11,
    },
  ];
  const CanonicalLink = () => {
    const location = useLocation();
    const canonicalUrl = window.location.origin + location.pathname;
    return (
        <link rel="canonical" href={canonicalUrl}/>
    );
  };
  return (
    <>
      <BrowserRouter>
        <ImageProvider>
          <InTheWorldProvider>
            <FaqsProvider>
              <ProductProvider>
                <NewsProvider>
                  <BusinessProvider>
                    <FooterProvider>
                      <ClientsProvider>
                        <LocationProvider>
                          <WhereBuyProvider>
                            <CorralonesFilterProvider>
                              <MapsProvider>
                                <CalculatorProvider>
                                  <ArticleSliderProvider>
                                    <BuscadorProvider>
                                      <AuditProvider>
                                        <SectionClientsProvider>
                                          <HomeProvider>
                                            <PgiModulesProvider>
                                              <Routes>
                                                <Route
                                                  path="/"
                                                  element={<Layout />}
                                                >
                                                  <Route
                                                    index
                                                    element={
                                                      <Suspense fallback={null}>
                                                        <Home />
                                                      </Suspense>
                                                    }
                                                  />
                                                  <Route
                                                    path="/calculadora-losa-con-viguetas"
                                                    element={<Calculator />}
                                                  />
                                                  <Route
                                                    path="/tensolite-en-el-mundo"
                                                    element={<EnElMundo />}
                                                  />
                                                  <Route
                                                    path="/trabajar-con-nosotros"
                                                    element={<UploadCV />}
                                                  />
                                                  <Route
                                                    path="/donde-comprar"
                                                    element={<WhereBuy />}
                                                  />
                                                  <Route
                                                    path="/donde-comprar"
                                                    search="*"
                                                    element={
                                                      <Navigate to="/donde-comprar" />
                                                    }
                                                  />

                                                  <Route
                                                    path="/tensonews"
                                                    element={<TensoBlog />}
                                                  />
                                                  <Route
                                                    path="/blogs"
                                                    search="*"
                                                    element={
                                                      <Navigate to="/tensonews" />
                                                    }
                                                  />
                                                  <Route
                                                    path="/tensoblog"
                                                    element={<TensoNews />}
                                                  />
                                                  <Route
                                                    path="/noticias/:id"
                                                    element={<Noticias />}
                                                  />
                                                  {newsSeo.map(
                                                    ({
                                                      id,
                                                      oldPath,
                                                      newPath,
                                                    }) => (
                                                      <Route
                                                        key={id}
                                                        path={`/${oldPath}`}
                                                        search="*"
                                                        element={
                                                          <Navigate
                                                            to={`${newPath}`}
                                                          />
                                                        }
                                                      />
                                                    )
                                                  )}
                                                  <Route
                                                    path="/clientes"
                                                    element={
                                                      <ProtectedRouteClients>
                                                      <Navigate to="/calculadora-losa-con-viguetas" />
                                                      </ProtectedRouteClients>
                                                    }
                                                  />

                                                  {/*EnElMundo.jsx*/}
                                                  <Route
                                                    path="/tensolite-en-el-mundo"
                                                    element={
                                                      <MapsProvider>
                                                        <EnElMundo />
                                                      </MapsProvider>
                                                    }
                                                  />
                                                  <Route
                                                    path="/tensomundo"
                                                    search="*"
                                                    element={
                                                      <Navigate to="/tensolite-en-el-mundo" />
                                                    }
                                                  />
                                                  {/**FAQS */}
                                                  <Route
                                                    path="/preguntas-frecuentes"
                                                    element={
                                                      <PreguntasFrecuentes />
                                                    }
                                                  />
                                                  <Route
                                                    path="/resultado-busqueda"
                                                    element={
                                                      <ResultadoBusqueda />
                                                    }
                                                  />
                                                  <Route
                                                    path="/Listaproducto"
                                                    element={<ListaProducto />}
                                                  />
                                                  {/* Sección productos */}
                                                  <Route
                                                    path="/producto/:id"
                                                    element={<Products />}
                                                  />
                                                  <Route
                                                    path="/producto-especial/:id"
                                                    element={<Products />}
                                                  />
                                                  {/* Sección sub-productos */}
                                                  <Route
                                                    path="/producto/:name/:id"
                                                    element={
                                                      <DetalleProducto />
                                                    }
                                                  />
                                                  <Route
                                                    path="/instalacion/:id"
                                                    element={
                                                      <InstalacionProductos />
                                                    }
                                                  />
                                                  {productSeo.map(
                                                    ({
                                                      oldPath,
                                                      newPath,
                                                      id,
                                                      linea,
                                                    }) =>
                                                      linea ? (
                                                        <Route
                                                          key={id}
                                                          path={`/${oldPath}`}
                                                          search="*"
                                                          element={
                                                            <Navigate
                                                              to={`${newPath}`}
                                                            />
                                                          }
                                                        />
                                                      ) : (
                                                        <Route
                                                          key={id}
                                                          path={`/${oldPath}`}
                                                          search="*"
                                                          element={
                                                            <Navigate
                                                              to={`${newPath}`}
                                                            />
                                                          }
                                                        />
                                                      )
                                                  )}
                                                  <Route
                                                    path="/nueva-noticias/:id"
                                                    element={<NewsTensoBlog />}
                                                  />
                                                  {newsSeo.map(
                                                    ({
                                                      id,
                                                      oldPath,
                                                      newPath,
                                                    }) => (
                                                      <Route
                                                        key={id}
                                                        path={`/${oldPath}`}
                                                        search="*"
                                                        element={
                                                          <Navigate
                                                            to={`${newPath}`}
                                                          />
                                                        }
                                                      />
                                                    )
                                                  )}
                                                  <Route
                                                    path="/nueva-noticias-multimedia/:id"
                                                    element={<NewsTensoBlog />}
                                                  />
                                                  <Route
                                                    path="/noticias-multimedia/:id"
                                                    element={
                                                      <NoticiaMultimedia />
                                                    }
                                                  />

                                                  <Route
                                                    path="/somos-tensolite"
                                                    element={<Institucional />}
                                                  />
                                                  <Route
                                                    path="/nosotros"
                                                    search="*"
                                                    element={
                                                      <Navigate to="/somos-tensolite" />
                                                    }
                                                  />

                                                  <Route
                                                    path="clientes/login"
                                                    element={<LoginCliente />}
                                                  />
                                                  <Route
                                                    path="clientes/registro"
                                                    element={
                                                      <RegistroCliente />
                                                    }
                                                  />
                                                  <Route
                                                    path="clientes/olvide-password"
                                                    element={
                                                      <RecuperoPassword />
                                                    }
                                                  />
                                                  <Route
                                                    path="clientes/nuevo-password/:token"
                                                    element={
                                                      <NewPassword />
                                                    }
                                                  />
                                                  <Route
                                                    path="/instalacion-productos"
                                                    element={
                                                      <InstalacionProductos />
                                                    }
                                                  />
                                                  <Route
                                                    path="/contacto"
                                                    element={<Contact />}
                                                  />
                                                  {/**/}
                                                  <Route
                                                    path="/error404"
                                                    element={
                                                      <Page404 />
                                                    }
                                                  />
                                                  <Route
                                                    path="*"
                                                    element={<Page404 />}
                                                  />
                                                </Route>
                                                <Route
                                                  path="/galeria"
                                                  element={<GaleriaFotos />}
                                                />
                                                <Route path="/pgi/login">
                                                  <Route
                                                    index
                                                    element={<Login />}
                                                  />
                                                </Route>
                                                <Route
                                                  path="/pgi"
                                                  element={
                                                    <ProtectedRoutePGI>
                                                      <LayoutPgi />
                                                    </ProtectedRoutePGI>
                                                  }
                                                >
                                                  <Route
                                                    index
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <IndexNotificaciones />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-home"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <HomeProvider>
                                                          <HomePgi />
                                                        </HomeProvider>
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-news"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <HomePgiNews />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/usuarios"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <Usuarios />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/configuracion"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <Config />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-preguntas-frecuentes"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <FaqsHomePgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/galeria"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <GaleriaPgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/galeriav2"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <GaleriaPgiV2 />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-productos"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <ProductosPgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-subproductos"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <SubProductosPgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-empresa"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <BusinessPgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-intheworld"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <MapsProvider>
                                                          <InTheWorldPgi />
                                                        </MapsProvider>
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-calculadora"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <CalculatorPGI />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-corralones"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <CorralonesFilterProvider>
                                                          <MapsProvider>
                                                            <CorralonesPgi />
                                                          </MapsProvider>
                                                        </CorralonesFilterProvider>
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/edit-footer"
                                                    element={
                                                      <ProtectedRoutePGI>
                                                        <FooterPgi />
                                                      </ProtectedRoutePGI>
                                                    }
                                                  />
                                                  <Route
                                                    path="/pgi/seccion-clientes"
                                                    element={
                                                      <SectionsClientsPgi />
                                                    }
                                                  />
                                                </Route>
                                              </Routes>
                                            </PgiModulesProvider>
                                          </HomeProvider>
                                        </SectionClientsProvider>
                                      </AuditProvider>
                                    </BuscadorProvider>
                                  </ArticleSliderProvider>
                                </CalculatorProvider>
                              </MapsProvider>
                            </CorralonesFilterProvider>
                          </WhereBuyProvider>
                        </LocationProvider>
                      </ClientsProvider>
                    </FooterProvider>
                  </BusinessProvider>
                </NewsProvider>
              </ProductProvider>
            </FaqsProvider>
          </InTheWorldProvider>
        </ImageProvider>
        <CanonicalLink/>
      </BrowserRouter>
      <Toaster />
    </>
  );
};

export default AppRouter;
